module.exports = __webpack_public_path__ + "p4_img2.jpg?5f6cd6837a4120705b45aee0a4afee6c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p4/p4_img2.jpg
// module id = 109
// module chunks = 0